<template>
  <div>
    <top-header
      :type="3"
      :isShow="false"
      :bgColor="bgColor"
      :textColor="textColor"
    />
    <div class="top_banner">
      <img src="" alt="" />
    </div>
    <div class="info_word">
      <div>您可以购买的房屋总价为：</div>
      <div>
        <span>100</span>
        万元
      </div>
      <div>您可以购买的房屋单价为：</div>
      <div><span>122222</span>元/㎡</div>
    </div>
    <p class="info_word_bottom">以上结果仅供参考</p>
    <div class="bor_b">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">根据评估结果，为您推荐楼盘</h3>
        </div>
        <div class="list_con old_list">
          <div
            class="inner m_flex_box flex_vc"
            v-for="(item, index) in list"
            :key="index"
            @click="toDetail(item.id, item.mainId)"
          >
            <div class="inner_l">
              <img
                class="banner"
                v-lazy="imgPath + 'sClf/' + item.fileId + '.jpg'"
              />
            </div>
            <div class="new_r">
              <div class="m_flex_box flex_vc flex_jz tit">
                <h4 class="line_comp1">{{ item.tgmc ? item.tgmc : "" }}</h4>
                <i>在售</i
                ><!-- 接口没有返回数据 -->
              </div>
              <p class="line_comp1 col_gray">
                {{ item.xzqh ? item.xzqh : "-" }} /
                {{ item.zmjCount ? item.zmjCount + "m²" : "-" }} /
                {{ item.room ? item.room : "-" }}室{{
                  item.hall ? item.hall : "-"
                }}厅
              </p>
              <div class="m_flex_box flex_jz">
                <div class="price m_flex_box flex_vb">
                  <h4>
                    {{
                      item.listedPrice ? item.listedPrice / 10000 + "万" : "-"
                    }}
                  </h4>
                  <p>{{ item.unitPrice ? item.unitPrice + "元/平" : "-" }}</p>
                </div>
                <a
                  @click.stop="
                    callPhone_(
                      item.phoneNum == null ? '暂无' : item.phoneNum,
                      item.listedType,
                      item.listedUserId
                    )
                  "
                  class="tel"
                  ><img src="@/assets/img/tel.png" alt=""
                /></a>
              </div>
              <div class="num m_flex_box flex_vc">
                <img src="@/assets/img/check.png" alt="" /><span>核验编码</span
                >{{ item.uniqueCode ? item.uniqueCode : "暂无" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import topHeader from "@/components/header";
export default {
  data() {
    return {
      bgColor: "transparent",
      textColor: "#fff",
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  components: {
    topHeader,
  },
  methods: {
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > (document.documentElement.clientWidth / 7.5) * 4.6) {
        this.textColor = "#000";
        this.bgColor = "#fff";
      } else {
        this.textColor = "#fff";
        this.bgColor = "transparent";
      }
    },
  },
};
</script>
<style scoped lang='less'>
.info_word {
  padding: 0.5rem 0 0.5rem 0.5rem;
  div {
    font-size: 0.3rem;
    margin-top: 0.2rem;
    &:nth-child(odd) {
      font-weight: 900;
    }
    span {
      color: #ff3333;
      font-weight: 900;
      display: inline-block;
      width: 1.4rem;
    }
  }
}
.info_word_bottom {
  text-align: center;
  color: #a1a1a1;
  padding: 0.5rem 0;
  border-bottom: 0.3rem solid #e5e5e5;
}
.top_banner {
  position: relative;
  height: 4.64rem;
  img {
    height: 4.64rem;
    width: 100%;
  }
}
.main_inner {
  width: 7.04rem;
  margin: 0 auto;
  display: block;
  padding: 0.4rem 0;
  .priceLocation {
    flex: 1;
    position: relative;
    span {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .tit_con {
    margin-bottom: 0.28rem;
  }
  .inner_tit {
    font-size: 0.34rem;
    font-weight: 800;
  }
  .arrow {
    color: #aaabae;
    font-size: 0.24rem;
    i {
      margin-left: 0.12rem;
    }
  }
  .text_con {
    line-height: 0.42rem;
  }
}
</style>